export interface Cookies {
  [key: string]: string | undefined;
  _ga?: string;
}

export const getCookiesFromString = (cookiesString: string, whitelist?: string[]) => {
  const cookiesList = cookiesString.split(';');

  return cookiesList.reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');

    if (!key || (whitelist && !whitelist.includes(key.trim()))) return acc;

    return {
      ...acc,
      [key?.trim()]: value?.trim(),
    };
  }, {} as Cookies);
};
